import React, { Component, Fragment, useEffect } from 'react';
//import { render } from 'react-dom';
//import Hello from './Hello';
import './style.css';
import '../assets/css/formulario.css'
import Swal from 'sweetalert2';
import Loading from "react-fullscreen-loading";
import ReCAPTCHA from 'react-google-recaptcha';

export class TerminosCondicionesQuimica extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div>Términos Química</div>
        )
    }
}

export default TerminosCondicionesQuimica;


export function TratamientoDatosQuimicaString() {
    return (
        `
    <div class=WordSection1 style='text-align:left;margin:15px'>
        <p style='font-size:20.0pt;text-align:center;mso-margin-bottom-alt:auto;line-height:normal;
        background:white'><strong>Aviso Legal de Tratamiento de Datos</strong></p>
        <p style='mso-margin-bottom-alt:auto;line-height:normal;
        background:white'>Al completar y enviar este formulario, usted consiente que la ESPOL utilice sus datos
        personales para contactarlo y brindarle mayor información sobre el evento seleccionado,
        y para informarle sobre futuros eventos que podrían ser de
        su interés. Además, le informamos que esta información puede ser compartida con las
        empresas y fundaciones de la ESPOL, con el objetivo de cumplir con la finalidad
        mencionada anteriormente. Su información no será utilizada para otros fines no declarados.</p>
    </div>
        `
    )
}

export function TerminosCondicionesQuimicaString() {
    return (
        `
            <div class=WordSection1 style='text-align:left;margin:15px'>

<p class=MsoNormal style='text-align:center;mso-margin-bottom-alt:auto;line-height:normal;
background:white'><b><span style='font-size:20.0pt;;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Términos y Condiciones de Uso</span></b><span
style='font-size:20.0pt;font-family:"NeueHansKendrick-light",serif;mso-fareast-font-family:
"Times New Roman";mso-bidi-font-family:"Times New Roman";color:#212529;
mso-fareast-language:ES-EC'><o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Los Términos y Condiciones de Uso de
la Escuela de Ingeniería Química nos establecen los parámetros de relaciones
con nuestros Usuarios, las leyes aplicables y nuestra forma de trabajar. Toda
persona que acceda o utilice nuestro servicio, en adelante “Usuario”, se acoge
a los términos y condiciones de la Escuela de Ingeniería Química. En caso de no
estar de acuerdo con nuestras políticas, abstenerse de utilizar el
sitio/servicio.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>El Usuario deberá leer, comprender y
aceptar los términos y condiciones expuestos, previo a su registro como Usuario
de la página web <span style=''>http://www.fcnm.espol.edu.ec/es/formulario-escuela-de-ingenieria-de-quimica.</span><o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><b><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Proveedor de servicios</span></b><span
style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;mso-fareast-font-family:
"Times New Roman";mso-bidi-font-family:"Times New Roman";color:#212529;
mso-fareast-language:ES-EC'><o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Los servicios de la Escuela de
Ingeniería Química los proporciona y se contratan con: ESPOLTECH E.P., empresa
pública constituida al amparo de las leyes ecuatorianas, domiciliada en el Km.
30.5 vía perimetral Campus Gustavo Galindo, Guayaquil.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>El 01 de julio de 2014 se celebró el
Convenio de Alianza Estratégica entre la Escuela Superior Politécnica del
Litoral (ESPOL) y la Empresa Pública de Servicios ESPOL-TECH E.P., en cuyo
objeto se estableció que ESPOL-TECH_EP podrá brindar “(…) las asesorías,
consultorías, control, administración y prestar servicio en el manejo financiero
gerencia y fiscalización de toda clase de proyectos, bien sean estos de
inversión, investigación científica, desarrollo, transferencia de tecnología y
proyectos educativos que la ESPOL encargue a ESPOL-TECH E.P. (…)”.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><b><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Requisitos para contratar</span></b><span
style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;mso-fareast-font-family:
"Times New Roman";mso-bidi-font-family:"Times New Roman";color:#212529;
mso-fareast-language:ES-EC'><o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Nuestro sitio web y sus servicios
están disponibles únicamente para las personas que tengan capacidad legal para
contratar. Toda persona que no tenga esa capacidad por edad u otra condición,
no podrá utilizar nuestra plataforma. Serán eliminados los usuarios que no
cumplan con esta condición.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><b><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Información y cuenta del Usuario</span></b><span
style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;mso-fareast-font-family:
"Times New Roman";mso-bidi-font-family:"Times New Roman";color:#212529;
mso-fareast-language:ES-EC'><o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Para fines exclusivos de registro en
nuestra plataforma/sitio web, es obligatorio completar la información requerida
por la Escuela de Ingeniería Química. La información entregada por el Usuario
deberá ser verdadera y precisa; así mismo, el Usuario tiene el compromiso de
actualizarla en caso de haber cambios en su información personal.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>La Escuela de Ingeniería Química no
se responsabiliza por la veracidad de la información provista por los Usuarios,
siendo estos últimos quienes garantizan y responderán frente a terceros
respecto de los datos registrados.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>La Escuela de Ingeniería Química está
facultado para solicitar a los Usuarios cualquier dato adicional o documento
para corroborar la información receptada, así como suspender o eliminar la
cuenta del Usuario cuya información no se pueda comprobar. De los Usuarios
eliminados o suspendidos se eliminará todo producto publicado en nuestra
plataforma, y se suspenderán las ventas realizadas que no hayan sido enviadas,
sin derecho algún a reclamo por concepto de pagos o valores pendientes.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>El Usuario una vez registrado
obtendrá su cuenta personal mediante el ingreso de su usuario o correo
electrónico, y su clave de seguridad personal seleccionada. El Usuario es
responsable de mantener la confidencialidad de su usuario y contraseña, la cual
es personal e intransferible. Se prohíbe cualquier tipo de cesión o
transferencia del Usuario o Cuenta creada.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>El Usuario asume toda la
responsabilidad respecto de todas las operaciones efectuadas con su Usuario, en
adelante “Cuenta”, por ser de carácter personal y de exclusivo uso de su
persona. Cualquier uso no autorizado por el Usuario en su cuenta, deberá ser
reportado inmediatamente a la Escuela de Ingeniería Química<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>La Escuela de Ingeniería Química se
encuentra facultado para no aceptar toda solicitud ingresada, sin exponer
motivos, y sin derecho a reclamo o pago de indemnización alguna.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><b><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Objeto de la Plataforma</span></b><span
style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;mso-fareast-font-family:
"Times New Roman";mso-bidi-font-family:"Times New Roman";color:#212529;
mso-fareast-language:ES-EC'><o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>El objeto de la plataforma es
establecer la conexión entre los compradores y vendedores. La Escuela de
Ingeniería Química en calidad de “vendedor” podrá ofertar sus productos a los
usuarios “compradores”, mediante las herramientas que facilita nuestra
plataforma la Escuela de Ingeniería Química. Las aceptaciones de la oferta solo
serán válidas una vez que el pago sea confirmado por el Usuario “comprador”,
momento en el cual se perfeccionará el contrato de compraventa entre ambos
usuarios.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><b><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Usuario vendedor</span></b><span
style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;mso-fareast-font-family:
"Times New Roman";mso-bidi-font-family:"Times New Roman";color:#212529;
mso-fareast-language:ES-EC'><o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Se denominará usuario vendedor,
aquellos que acepten los presentes términos y condiciones con el objetivo de
ofertar productos dentro de las herramientas que ofrece la plataforma de la
Escuela de Ingeniería Química. La Escuela Superior Politécnica del Litoral se
responsabiliza de la calidad y veracidad de los productos ofertados y vendidos,
a través del Sitio Web.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><b><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Usuarios compradores</span></b><span
style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;mso-fareast-font-family:
"Times New Roman";mso-bidi-font-family:"Times New Roman";color:#212529;
mso-fareast-language:ES-EC'><o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Se conocen como usuarios compradores,
quienes busquen realizar una compra a la Escuela de Ingeniería Química de los
productos ofertados. Los usuarios compradores serán responsables de los métodos
de pago utilizados para concretar la compraventa de los productos requeridos.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Respecto del pago se debe de tener en
consideración lo siguiente:<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>1. Quedo a potestad del banco emisor
aceptar o no el pago<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>2. Solo visa y MasterCard en corriente<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><b><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Producto ofertado</span></b><span
style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;mso-fareast-font-family:
"Times New Roman";mso-bidi-font-family:"Times New Roman";color:#212529;
mso-fareast-language:ES-EC'><o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Todo producto ofertado y publicado
dentro de la plataforma de la Escuela de Ingeniería Química deberá ser
descriptivo respecto de toda información relevante al producto y detalles del
producto.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>La Escuela de Ingeniería Química se
realizará del 5 al 9 de mayo 2025 en el Campus Prosperina de la ESPOL. Los
costos de participación son:<o:p></o:p></span></p>

<div align=center>

<table class=MsoNormalTable border=0 cellspacing=0 cellpadding=0
 style='background:white;border-collapse:collapse;mso-yfti-tbllook:1184'>
 <tr style='mso-yfti-irow:0;mso-yfti-firstrow:yes'>
  <td width=236 style='width:177.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal'><span
  style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
  mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Segoe UI";
  color:#212529;mso-fareast-language:ES-EC'>Estudiantes, docentes y <span
  class=SpellE>alumni</span> ESPOL<o:p></o:p></span></p>
  </td>
  <td width=65 style='width:48.75pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal'><span
  style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
  mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Segoe UI";
  color:#212529;mso-fareast-language:ES-EC'>$ 10.00<o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:1;mso-yfti-lastrow:yes'>
  <td width=236 style='width:177.0pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal'><span
  style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
  mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Segoe UI";
  color:#212529;mso-fareast-language:ES-EC'>Usuarios externos a ESPOL<o:p></o:p></span></p>
  </td>
  <td width=65 style='width:48.75pt;padding:.75pt .75pt .75pt .75pt'>
  <p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal'><span
  style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
  mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Segoe UI";
  color:#212529;mso-fareast-language:ES-EC'>$ 15.00<o:p></o:p></span></p>
  </td>
 </tr>
</table>

</div>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><b><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Usuario Comprador:</span></b><span
style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;mso-fareast-font-family:
"Times New Roman";mso-bidi-font-family:"Times New Roman";color:#212529;
mso-fareast-language:ES-EC'><o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Serán Usuario Compradores, aquellos
que hayan ingresado a nuestra plataforma con el fin de adquirir un producto
ofertado por parte la Escuela de Ingeniería Química. En base a la alianza
estratégica previamente descrita, ESPOL-TECH E.P. está facultado para recibir
en una cuenta a nombre de ESPOLTECH E.P., las sumas pagadas a través de los
medios de pago ofrecidos por la Escuela de Ingeniería Química, así como retener
dichas sumas hasta la confirmación de la venta en firme.<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><b><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Obligaciones de los Usuarios</span></b><span
style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;mso-fareast-font-family:
"Times New Roman";mso-bidi-font-family:"Times New Roman";color:#212529;
mso-fareast-language:ES-EC'><o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Todo Usuario comprador, que acepte
los presentes términos y condiciones, autoriza a la Escuela de Ingeniería
Química a utilizar su información para enviar y promocionar los servicios y
productos del Sitio, así como ser registrado dentro de la base de datos la
Escuela de Ingeniería Química para uso publicitario.&nbsp;<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><b><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Obligaciones del Usuario Vendedor</span></b><span
style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;mso-fareast-font-family:
"Times New Roman";mso-bidi-font-family:"Times New Roman";color:#212529;
mso-fareast-language:ES-EC'><o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>El Usuario debe tener capacidad legal
para vender el artículo/producto objeto de su oferta, así mismo deberá contar
con Registro Único de Contribuyentes activo debidamente emitido por el Servicio
de Rentas Internas ecuatoriano.&nbsp;<o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><b><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Ventas en firme:</span></b><span
style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;mso-fareast-font-family:
"Times New Roman";mso-bidi-font-family:"Times New Roman";color:#212529;
mso-fareast-language:ES-EC'><o:p></o:p></span></p>

<p class=MsoNormal style='mso-margin-bottom-alt:auto;line-height:normal;
background:white'><span style='font-size:12.0pt;font-family:"NeueHansKendrick-light",serif;
mso-fareast-font-family:"Times New Roman";mso-bidi-font-family:"Times New Roman";
color:#212529;mso-fareast-language:ES-EC'>Pasadas las veinticuatro horas (24h)
de recibido el Artículo/link en la bandeja de entrada por parte del Usuario
Comprador, no podrá solicitarse la devolución del valor del producto bajo
ningún concepto. Una vez haya transcurrido el período mencionado, se
considerará que la venta está en firme.<o:p></o:p></span></p>

<p class=MsoNormal><o:p>&nbsp;</o:p></p>

</div>
        `
    )
}